import React from "react";
import { connect } from "react-redux";
import { CardHeader } from "semantic-ui-react";
import { Icon } from "semantic-ui-react";
import { Button } from "semantic-ui-react";
import { Segment } from "semantic-ui-react";
import { Menu } from "semantic-ui-react";
import { Header } from "semantic-ui-react";
import { getCurrentEmployment } from "../../selectors/employments";
import EditModal from "../forms/EditModal";
import SignatureForm from "./SignatureForm";

class Signature extends React.Component {
  render() {
    let fileName = this.props.fileName
   let editButtonText = fileName ?
     I18n.t(`api.forms.employment.signature_form.edit`)
     : I18n.t(`api.forms.employment.signature_form.new`)

    let EditButton = <EditModal entityName="employment" EntityForm={SignatureForm}
                                header={I18n.t(`api.forms.employment.signature_form.new`)} entityId={this.props.entityId}
                                trigger={(props) => {return (<Button onClick={props.onClick} icon='pencil' content={editButtonText}/>)}}/>

    return (
      <Segment basic loading={this.props.loading}>
          <Header dividing as="h2">
            {I18n.t(`api.forms.employment.signature_form.title`)}
          </Header>

        <div className={fileName ? "ui card" : undefined}>
          {fileName && <div className="content">
             <CardHeader>
               <Icon name={"check"} color={"green"}/>
               {fileName}
             </CardHeader>
           </div>}
          <div className={fileName ? "extra content" : undefined}>{EditButton}</div>
        </div>
      </Segment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const employment = getCurrentEmployment(state)
  return {
    entityId: employment?.id,
    fileName: employment?.signatureTitle,
    loading: state.meta.employment?.loading,
    error: state.meta.employment?.error
  }
}

export default connect(mapStateToProps, null)(Signature);
